import React from 'react';

import { useDispatch, useSelector } from '@lumapps/redux/react';

import { actions, selectTotalUnreadCount } from '../ducks/unreadCounts';

export const useUnreadCount = () => {
    const totalCount = useSelector(selectTotalUnreadCount);

    return { totalCount };
};

/** Automatically unregisters the source on unmount. */
export const useRegisterUnreadCount = (source: string, count: number) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(actions.registerUnreadCount({ source, count }));
    }, [source, count, dispatch]);

    React.useEffect(
        () => () => {
            dispatch(actions.unregisterUnreadCount(source));
        },
        [source, dispatch],
    );
};
